import { Button, Col, Container, Row } from 'react-bootstrap';
import filterIcon from '../../Asset/image/filter.png';
import CustomImage from '../../CommonComponents/CustomImage';
import Form from 'react-bootstrap/Form';
import { LanguagesList, isEmpty } from '../../data/constants';
import { useState } from 'react';
import { toast } from 'react-toastify';

function RightComponent({ promptFilter, setPromptFilter, replyLanguage, setReplyLanguage, tone, setTone, formality, setFormality }) {
    /* @ts-ignore */
    const [selected, setSelected] = useState(-1);
    const [selectedTone, setSelectedTone] = useState(-1);
    const [error, setError] = useState({});
    const checkValidation = () => {
        try {
            let isValid = true;
            let errors = error;
            if (!promptFilter || isEmpty(promptFilter)) {
                isValid = false;
                errors = { ...errors, filterPrompt: true }
            }
            if (!replyLanguage || isEmpty(replyLanguage)) {
                isValid = false;
                errors = { ...errors, languageReply: true }
            }
            if (!tone || isEmpty(tone)) {
                isValid = false;
                errors = { ...errors, tone: true }
            }
            if (!formality || isEmpty(formality)) {
                isValid = false;
                errors = { ...errors, formality: true }
            }
            setError(errors);
            if (isValid)
                toast.success("Filters added successfully.")
            else
                toast.error("Please select all the filters.")
            return isValid;
        } catch (error) {
            console.log(error)
        }
    }
    const renderError = (msg, value, style) => {
        return (
            value ? (
                <h6 className="blog_error_text4 signUpMsg12 mt-2" style={{ marginBottom: 10, marginTop: style !== undefined ? 10 : -10 }}>
                    {msg}
                </h6>) : null)
    }
    const reset = () => {
        setPromptFilter("");
        setReplyLanguage("");
        setFormality("");
        setTone("");
        setSelected(3)
        setSelectedTone(-1)
    }
    return (<>

        <div className="container p-1" >
            <div className=" rightSideBox d-none d-lg-block">
                <div className="row d-flex justify-content-space-between" >
                    <div className="col-md-2">
                        <CustomImage className="iconStyle" src={filterIcon} /></div>
                    <div className="col-md-10">
                        <h3 className="whiteTitle" >Filter</h3>
                    </div>
                </div>
                <div className="sidemenu_scroll sidespacing_scroll" style={{ overflowY: 'auto' }}>
                    <p className='text-label'>Formality</p>
                    <div className="row">
                        <div className="col-md-4 filterBox " style={selected == 0 ? {
                            background: "linear-gradient(0deg, #0074FE, #0074FE),linear-gradient(0deg, #313131, #313131)"
                        } : null} onClick={() => { setFormality("casual"); setSelected(0); setError({ ...error, formality: false }) }}>Casual</div>
                        <div className="col-md-4 filterBox" style={selected === 1 ? { background: "linear-gradient(0deg, #0074FE, #0074FE),linear-gradient(0deg, #313131, #313131)" } : null} onClick={() => { setFormality("neutral"); setSelected(1); setError({ ...error, formality: false }) }}>
                            Neutral
                        </div>
                    </div>
                    <Row>
                        <div className=" col-md-4 filterBox my-2 " style={selected === 2 ? { background: "linear-gradient(0deg, #0074FE, #0074FE),linear-gradient(0deg, #313131, #313131)" } : null} onClick={() => { setFormality("Formal"); setSelected(2); setError({ ...error, formality: false }) }}>Formal</div>
                    </Row>
                    {renderError('Please select formality! ', error.formality)}
                    <p className='text-label mt-2 '>Tone</p>
                    <Row>
                        <Col md={5} className="filterBox" style={selectedTone === 0 ? { background: "linear-gradient(0deg, #0074FE, #0074FE),linear-gradient(0deg, #313131, #313131)" } : null} onClick={() => { setTone("personalble"); setSelectedTone(0); setError({ ...error, tone: false }) }}>Personable</Col>
                        <Col md={5} className="filterBox" style={selectedTone === 1 ? { background: "linear-gradient(0deg, #0074FE, #0074FE),linear-gradient(0deg, #313131, #313131)" } : null} onClick={() => { setTone("confident"); setSelectedTone(1); setError({ ...error, tone: false }) }}> Confident </Col>
                    </Row>
                    <Row>
                        <Col md={5} className="filterBox my-2 " style={selectedTone === 2 ? { background: "linear-gradient(0deg, #0074FE, #0074FE),linear-gradient(0deg, #313131, #313131)" } : null} onClick={() => { setTone("empathetic"); setSelectedTone(2); setError({ ...error, tone: false }) }}>Empathetic</Col>
                        <Col md={5} className="filterBox my-2" style={selectedTone === 3 ? { background: "linear-gradient(0deg, #0074FE, #0074FE),linear-gradient(0deg, #313131, #313131)" } : null} onClick={() => { setTone("engaging"); setSelectedTone(3); setError({ ...error, tone: false }) }}> Engaging</Col>
                    </Row>
                    <Row>
                        <Col md={5} className="filterBox " style={selectedTone === 4 ? { background: "linear-gradient(0deg, #0074FE, #0074FE),linear-gradient(0deg, #313131, #313131)" } : null} onClick={() => { setTone("witty"); setSelectedTone(4); setError({ ...error, tone: false }) }}>Witty</Col>
                        <Col md={5} className="filterBox" style={selectedTone === 5 ? { background: "linear-gradient(0deg, #0074FE, #0074FE),linear-gradient(0deg, #313131, #313131)" } : null} onClick={() => { setTone("direct"); setSelectedTone(5); setError({ ...error, tone: false }) }}> Direct</Col>
                    </Row>
                    {renderError('Please select tone! ', error.tone)}
                    <p className='text-label mt-3'>Prompts</p>
                    <div style={{ marginRight: "3%" }}>
                        <Form.Select className="input-box" value={promptFilter} onChange={(e) => { setPromptFilter(e.target.value); setError({ ...error, filterPrompt: false }) }}>
                            <option>Select prompts</option>
                            <option value="1" >Check my grammar and punctuation</option>
                            <option value="2" >Suggest improvements for clarity</option>
                            <option value="3">Enhance my writing style</option>
                            <option value="4">Assist with word choice</option>
                            <option value="5">Provide sugestions for sentence structure</option>
                        </Form.Select>
                        {renderError('Please select prompts! ', error.filterPrompt)}
                    </div>
                    <p className='text-label mt-3'>I write in</p>
                    <div style={{ marginRight: "3%" }}>
                        <Form.Select className="input-box" value={replyLanguage} onChange={(e) => { setReplyLanguage(e.target.value); setError({ ...error, languageReply: false }) }}>
                            <option>Select Language</option>
                            {LanguagesList?.map((item, index) =>
                                <option key={index} onClick={() => setReplyLanguage(item?.name)}>{item?.name}</option>
                            )}
                        </Form.Select>
                        {renderError('Please select language! ', error.languageReply)}
                    </div>
                </div>
                <p className='commentText my-4 mb-4'>
                    These text settings will apply to any text you generate with TAMARA.</p>
                <div className="row px-1">
                    <div className='d-flex justify-content-left align-items-center'>
                        <div>
                            <button className="btn-secondary btn reset_button me-4" onClick={() => reset()}>Reset</button>
                        </div>
                        <div>
                            <Button type='submit' className='submit_button'
                                onClick={() => {
                                    // checkValidation();
                                    toast.success("Filter added successfully.")
                                }}
                            >Submit</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </>);
}

export default RightComponent;
